import { Component, OnInit } from '@angular/core';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
    selector: 'app-membership-banner',
    templateUrl: './membership-banner.component.html',
    styleUrls: ['./membership-banner.component.scss']
})
export class MembershipBannerComponent implements OnInit {
    // TimeZone related configuration
    public USATimeZone:boolean = false;
    public CanadaTimeZone:boolean = false;

    constructor(private timezoneService: TimeZoneService){

    }

    ngOnInit() {
        this.USATimeZone = this.timezoneService.checkUSATimeZone();
        this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
    }
}
